import { metricSentenceCase } from 'modules/productAnalytics/utils';
import { DateCell, TableCell } from 'ui/tableCell';
import { WebLink2 } from 'ui/theme';
import { StyledLinkCell } from './Styled';
import { ColumnData, REPLY_TYPE } from './type';

export const COLUMNS: ColumnData[] = [
  {
    name: 'Reply type',
    align: 'flex-start',
    value: 'messageType',
    RowCell: ({ row }) => <TableCell>{metricSentenceCase(row.messageType)}</TableCell>,
  },
  {
    name: 'Content',
    align: 'flex-start',
    value: 'messageText',
    RowCell: ({ row }) => {
      const linkableTypes = new Set([
        REPLY_TYPE.IMAGE,
        REPLY_TYPE.VIDEO,
        REPLY_TYPE.DOCUMENT,
        REPLY_TYPE.STICKER,
      ]);

      const isLinkable = linkableTypes.has(row.messageType);

      if (isLinkable) {
        return (
          <TableCell>
            <StyledLinkCell
              href={row.messageUrl ?? row.messageText}
              hasOpenNewTabIcon
              target="_blank"
              rel="noopener noreferrer"
            >
              {row.messageText ?? row.messageUrl}
            </StyledLinkCell>
          </TableCell>
        );
      }

      return <TableCell>{row.messageText}</TableCell>;
    },
  },
  {
    name: 'User',
    align: 'flex-start',
    value: 'userEmail',
    RowCell: ({ row }) => (
      <TableCell>
        <WebLink2 href={`mailto:${row.userEmail}`}>{row.userEmail}</WebLink2>
      </TableCell>
    ),
  },
  {
    name: 'Timestamp',
    align: 'flex-start',
    value: 'createdAt',
    RowCell: ({ row }) => (
      <DateCell timestamp={row.createdAt} isRelative={false} isUnderlined={false} />
    ),
  },
];
